<template>
    <div>
        <!-- <transition leave-active-class="transition ease-in duration-1000" leave-from-class="opacity-100" leave-to-class="opacity-0"> -->
        <transition name="slide-fade" leave-active-class="transition ease-in duration-3000">
            <div v-show="on" :class="'q-mx-md text-'+color">
                <slot />
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        props: {
            on: Boolean,
            color: {String, default: 'green-8'}
        },
    }
</script>
